
import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES } from './../../common/helper/common-imports.component.js';
import{  RowsPerPageSelector, SearchTable, DataTable,customDataTableStyles } from './../../common/helper/table-imports.js';
import MerchantsService from "../../../services/merchants-service.js";
import { agentsList } from "./../../../actions/agent-actions.js";
import FundsService from '../../../services/funds-service.js';
import { statementsColoumns } from './funds-col.component.js'
import MUIButton from "../../common/miui-component/mui-button.jsx";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchFilter from  "./../../common/helper/searchFilter.js";
import { transactionSerachFormData } from '../../common/helper/form-constants.js';

const FundsListing = () => { 
  const dispatch = useDispatch();
  const [role,setUserRole] = useState('');
  const [status,setStatus] = useState('');
  const [isOpenDrawer, setIsOpenDrawer] = React.useState(false);

  const [loading, setLoading] = useState(false);
  const [transaction , setTransactionData] = useState();
  const [dataTableKey, setDataTableKey] = useState(0);
  const navigate = useNavigate();
  const userData = useSelector(state => state.authReducer);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [pageNo, setPageNo] = useState(0);
  const [totalRows, setTotalRows] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [agents, setAgents] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [formData,setFormData] = useState({...transactionSerachFormData, from_date: '', to_date: ''})
  const paginationComponentOptions = { 
    noRowsPerPage :true
  }
  const [filterData, setFilterData] = useState({
    end_date: '',
    start_date: '',
    customer_id: '',
    agent_id: '',
    payment_method: ''
  });
  const [columns,setColumns] = useState(statementsColoumns());


  const listTransactions = (fiterReset = false, pageNumber, rowsPage,filterData) => {
  
    let transaction =  FundsService.fundHistory(fiterReset ? {} : filterData, pageNumber, rowsPage, status)
    
    setLoading(true);
   
    transaction.then(response => {
      console.log(response)
      const records = response.data.data.list
      
      setTotalRows(response.data.data.total_records)



      setTransactionData(records)
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      try {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
      } catch (e){
        toast.error( MESSAGES.SERVER_ERROR)
      }
    });
  }
 
  
 


  useEffect(() => {
    let userRole;
    if(userData && userData.user && userData.user.data) {
       userRole = userData.user.data.role.role_code
       setUserRole(userRole)
    }
    listTransactions(false,0,10,filterData);
  
   
    document.body.style.backgroundImage = '';
    document.body.style.backgroundColor = '#f0f6fa';
    return () => {
      document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
    };
}, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const escapeRegExp = (string) => {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  };

  function getStatusText(statusCode) {
    switch (statusCode) {
      case 'P':
        return 'Pending';
      case 'R':
        return 'Raised';
      case 'RF':
        return 'Refund';
      case 'C':
        return 'Paid';
      default:
        return ''; // or handle unknown status codes
    }
  }
  
  const filteredData = transaction && transaction.filter((row) => {
    // Check if any value in the row matches the search term
    return Object.values(row).some((value) => {
      // If value is a status code, convert it to full status text
      if (value === row.status) {
        const statusText = getStatusText(row.status); // Get full status text
        return statusText.toLowerCase().includes(searchTerm.toLowerCase());
      }
      // Otherwise, directly test against the value
      return new RegExp(escapeRegExp(searchTerm), 'i').test(value);
    });
  });
      const applyFilter = (data) => {
        setFilterData(data)
        listTransactions(false, pageNo, rowsPerPage,data);
        setIsOpenDrawer(false)
      }
      
      const handleRowsPerPageChange = (value) => {
        let rowsPage = Number(value)
        setRowsPerPage(rowsPage);
        setDataTableKey(prevKey => prevKey + 1);
        listTransactions(false,pageNo, rowsPage,filterData)
      };
   
      const handlePageChange = page => {
        let pageNumber = page - 1;
        setPageNo(pageNumber)
        listTransactions(false, pageNumber, rowsPerPage,filterData);
      };

      useEffect(() => {
          if (filteredData?.length) {
            const element = document.getElementsByClassName("sc-bHCmUC");
            const childElement = element[0].children;
            for (let i = 0; i < childElement?.length; i++) {
              const ele = childElement[i].id.split("-")[1];
              if (Number(ele) % 2 === 0) {
                childElement[i].classList.add("odd-transaction-table");
              } else {
                childElement[i].classList.add("even-transaction-table");
              }
            }
          }
        }, [filteredData]);
      
    return(

      <>
        <LoaderOverlay loading={loading} />
   
        <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <div className="d-flex justify-content-between mb-3">
          <h4
            className="mb-0 updatename updatename1 align-self-center text-color-theme"
            style={{ marginTop: 0, fontWeight: 700, fontSize: "22px" }}
          >
            Statements
          </h4>
        <div>
            <div>
              <MUIButton
                btnOnClick={() => setIsOpenDrawer(true)}
                btnLabel="Filter"
                btnStyle={{
                  backgroundColor: "#ffffff",
                  color: "black",
                  borderRadius: "10px",
                  "&:hover": {
                    backgroundColor: "rgb(117 121 124 / 82%)",
                  },
                }}
              >
                <FilterListIcon sx={{ fontSize: "25px", marginLeft: "6px" }} />{" "}
              </MUIButton>
            </div>
            </div>
          </div>
        <div className="container" style={{backgroundColor: 'white'}}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button className="nav-link tbbtn active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true" >Statements</button>
              {/* <button className="nav-link tbbtn" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false"  onClick={() => resetSearch('Complete')} tabIndex={-1}>Complete Transaction</button> */}
            </div>
          </nav>
          <div className="filterBtn">
                        
          <SearchTable searchTerm={searchTerm} handleSearchChange={handleSearchChange}/>
                        <div>

 
      </div>
                  </div>
                  <RowsPerPageSelector rowsPerPage={rowsPerPage} onRowsPerPageChange={handleRowsPerPageChange} />
          <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px', paddingBottom: '15px'}}>
            <div className="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
              <main>
                <div className style={{paddingBottom: '30px'}}>
                  <div className style={{backgroundColor: 'white'}}>
                    <div className="tab-content" id="nav-tabContent" style={{}}>
                      <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <div className="col-md-12" style={{textAlign: 'right'}}>
                    
      </div>
                       
                        <div id="examplemgmwallet_wrapper" className="dataTables_wrapper dt-jqueryui no-footer">

                        <DataTable key={dataTableKey}
                            columns={columns}
                              data={filteredData}
                              pagination
                              paginationComponentOptions={paginationComponentOptions} 
                              paginationPerPage={rowsPerPage} 
                              paginationServer
                              paginationTotalRows={totalRows}
                              onChangePage={handlePageChange}
                              customStyles={customDataTableStyles}

                        />
                        
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
     
          </div>
        </div>
      </div>
      <SearchFilter  
        isOpenDrawer={isOpenDrawer}
        setIsOpenDrawer={setIsOpenDrawer}
        fetchTransaction={(formData) => applyFilter(formData)}
        module = "Statement"
        formData={formData}
        setFormData={setFormData}
        />
      </>
    )
}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(FundsListing));